// extracted by mini-css-extract-plugin
export default {"capsuleLeft":"CorrectAnswers_capsuleLeft__uyegE"};